import isabellaPic from "@/public/images/artists/isabella.png";
import { Artist } from "@/types/types";

export const isabella = {
  id: "6",
  name: "Isabella",
  image: isabellaPic,
  description: `Isabella is pop singer with great storytelling abilities. Her versatile range allows for smooth transitions between lower and higher registers. Suitable for a range of genres including EDM, Indie, and soul.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fisabella-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "Indie"],
      secondary: ["Singer", "Soulful"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 67,
      },
    },
  },
} as const satisfies Artist;
